import * as React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalSurveyTemplate } from "../../amorg-common";
import { getActiveUser, getGlobalSurveyTemplates } from '../../api/adminClientApi';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { H1, H2 } from '../../designSystem/typography/Heading';
import { ButtonRow } from '../../designSystem/button/ButtonRow';
import { LinkButton } from '../../designSystem/button/LinkButton';
import { Divider } from '../../designSystem/Divider';
import { AmorgAdminPageProvider } from './AmorgAdminPageContext';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { AdminTab } from './_components/AdminTab';
import { SurveyTemplateList } from './_components/SurveyTemplateList';

export default function AmorgAdminGlobalTemplates (): JSX.Element 
{
    const history = useHistory();

    const [loading, setLoading] = React.useState(true);
    const [globalTemplates, setGlobalTemplates] = React.useState<GlobalSurveyTemplate[]>([]);

    useEffect(() =>
    {
        const init = async () =>
        {
            await getActiveUser(() => history.push(`/amorgy/login`));
            setGlobalTemplates(await getGlobalSurveyTemplates(() => history.push(`/amorgy/login`)));
            setLoading(false);
        };
        init().catch(console.error);
    }, []);

    const active = globalTemplates.filter(t => t.enabled);
    const inactive = globalTemplates.filter(t => !t.enabled);

    return (
        <AmorgAdminPageProvider>
            <LoadingPageOverlay loading={loading} />

            <SingleColumnLayout
                noDivider
                headerContainer={
                    <Flex flexDirection="column" gap={16}>
                        <AdminTab selectedTab='globaltemplates' />

                        <ButtonRow variant='right-aligned'>
                            <LinkButton variant="filled" icon="interface_actions_download" href={'/amorgy/importtemplate'} text='Importér skabelon' />
                        </ButtonRow>
                    </Flex>
                }

                contentContainer={
                    <Flex flexDirection="column" gap={16}>
                        <H1>Globale skabeloner</H1>

                        <H2>Aktive skabeloner</H2>
                        <SurveyTemplateList
                            templates={active}
                            buttons={[
                                {
                                    variant: 'filled',
                                    text: 'redigér',
                                    onClick: (templateId) => history.push(`/amorgy/edittemplate/${templateId}`)
                                }
                            ]} />

                        <div style={{ marginTop: '30px', marginBottom: '10px' }}>
                            <Divider />
                        </div>

                        <H2>Inaktive skabeloner {active.length}</H2>
                        <SurveyTemplateList
                            templates={inactive}
                            buttons={[
                                {
                                    variant: 'filled',
                                    text: 'redigér',
                                    onClick: (templateId) => history.push(`/amorgy/edittemplate/${templateId}`)
                                }
                            ]}
                        />
                    </Flex>
                }
            />
        </AmorgAdminPageProvider>
    );
}

